import { Component, OnInit, ViewChild } from '@angular/core';
import { KmsService } from '../../../kms.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { RulesAddComponent } from '../rules-add/rules-add.component';
import { SwCreateModalComponentService } from '../../../../../librarys/serves/sw-create-modal-component.service';
import { SwMassageConfirmComponent } from '../../../../../librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
@Component({
    selector: 'app-rules-query',
    templateUrl: './rules-query.component.html',
    styleUrls: ['./rules-query.component.css']
})
export class RulesQueryComponent implements OnInit {
    // 表格 规则数据
    datasRoules:any = [];

    // 表格 是否显示加载中
    isLoading: boolean = false;

    // 表格 选中的数据
    checkedData: any;

    // 表格 分页组件
    pageBase: any = {
        current: 1,
        size: 10
    }

    // 表格操作按钮
    toolbar = [
        { status: true, functionCode: 'add', functionName: '新增', icon: 'glyphicon glyphicon-plus', children: [] },
    ];

    // 删除确认组件
    @ViewChild("tirm1") tirm1: SwMassageConfirmComponent;
    constructor(
        private kmsService: KmsService,
        private message: SwMassageBoxService,
        private create: SwCreateModalComponentService,
    ) { }

    ngOnInit() {
        this.getRouleData();
    }

    // 请求规则序列号列表信息
    getRouleData() {
        this.isLoading = true;
        let Params = {
            current: this.pageBase.current,
            size: this.pageBase.size
        };
        this.kmsService.getSerialNumberList(Params).subscribe(
            result => {
                if (result.code == 200) {
                    this.isLoading = false;
                    this.datasRoules = [];
                    this.pageBase = result.data;
                    this.datasRoules = result.data.records;
                    console.log(this.datasRoules);
                } else {
                    this.message.waring(result.msg);
                }
            }
        );
    }

    // 表格 按钮点击事件
    handleOperationClick(event) {
        switch (event) {
            case "add": this.handleAddClick(); break; // 新增
        }
    }

    // 表格 选中数据方法
    handleSelectData(event) {
        this.checkedData = event;
    }

    // 表格 分页点击方法
    handlePageClick(event) {
        this.pageBase = event;
        this.getRouleData();
    }

    // 新增序列号配置
    handleAddClick() {
        let datas = {
            upOrAdd: "Add"
        }
        this.create.createModal(RulesAddComponent, datas, this.getRouleData.bind(this));
    }

    // 编辑系列号配置
    handleEditClick(data) {
        if (data.serialNumberId) {
            let datas = {
                upOrAdd: "Edit",
                serialNumberId: data.serialNumberId
            }
            this.create.createModal(RulesAddComponent, datas, this.getRouleData.bind(this));
        }
    }

    // 删除序列号配置
    handleDeleteClick(data) {
        if (data.serialNumberId) {
            this.tirm1.openCLick('确认删除吗？', (datas) => {
                if (datas) {
                    this.kmsService.deleteSerialNumberById([data.serialNumberId]).subscribe(
                        result => {
                            if (result.code == 200) {
                                this.message.success('数据删除成功！');
                                this.pageBase = {
                                    current: 1,
                                    size: 10
                                }
                                this.getRouleData();
                            }
                        }
                    )
                }
            })
        }
        
    }

}
